<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              insert_chart
            </v-icon>
            <span class="title">Dashboard</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-card>
                  <v-card-text>
                    <v-select
                      :items="listyears"
                      name="filteryear"
                      v-model="filter.year"
                      label="Tahun">
                    </v-select>
                  </v-card-text>
                  <v-card-actions class="justify-center">
                    <div class="text-center" v-if="loading.changedb">
                      <v-progress-circular
                        :width="3"
                        color="red"
                        indeterminate>
                      </v-progress-circular>
                    </div>
                    <v-btn v-if="!loading.changedb" block color="warning" dark @click="updateChart">Ubah</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="modulklian === '1'">
                <v-card
                  class="mx-auto text-center"
                  color="grey"
                  light>
                  <v-card-text>
                    <v-icon size="50">description</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.accbanjar }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: btnto, query: { type: 'accbanjar' } }">
                      Acc-banjar <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto text-center"
                  color="red"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>mail_outline</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.permohonan }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: btnto, query: { type: 'permohonan' } }">
                      Permohonan <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto text-center"
                  color="orange"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>sync</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.proses }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: btnto, query: { type: 'proses' } }">
                      Proses <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto text-center"
                  color="green"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>print</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.siap }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: btnto, query: { type: 'siap' } }">
                      Siap <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto text-center"
                  color="blue"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>assignment_turned_in</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.selesai }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: btnto, query: { type: 'selesai' } }">
                      Selesai <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card
                  class="mx-auto text-center"
                  color="grey darken-4"
                  dark>
                  <v-card-text>
                    <v-icon size="50" dark>unsubscribe</v-icon>
                  </v-card-text>
                  <v-card-text>
                    <div class="display-1">
                      {{ datacard.batal }}
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="justify-center">
                    <v-btn
                      block
                      text
                      :to="{ name: btnto, query: { type: 'batal' } }">
                      Batal <v-icon right>arrow_forward</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Home',
  data: () => ({
    api: process.env.VUE_APP_API,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    loading: {
      changedb: false,
    },
    filter: {
      year: new Date().getFullYear(),
    },
    datacard: {
      siap: 0,
      batal: 0,
      selesai: 0,
      proses: 0,
      permohonan: 0,
    },
    btnto: 'SuratGuest',
  }),
  created: () => ({
  }),
  mounted() {
    // for btn detail
    if (this.userrole === 'admin') {
      this.btnto = 'SuratAdmin';
    } else if (this.userrole === 'klian') {
      this.btnto = 'SuratKlian';
    } else {
      this.btnto = 'SuratGuest';
    }
    // init request
    if (this.tokenscr) {
      this.updateChart();
    }
  },
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'userbanjar',
    ]),
    listyears() {
      const year = new Date().getFullYear();
      const lyear = Array.from({length: year - 2017}, (value, index) => 2018 + index);
      lyear.push('all');
      return lyear;
    },
  },
  methods: {
    resetDataCard() {
      this.datacard = {
        siap: 0,
        batal: 0,
        selesai: 0,
        proses: 0,
        permohonan: 0,
        accbanjar: 0,
      };
    },
    updateChart() {
      this.resetDataCard();
      if (this.tokenscr) {
        this.loading.changedb = true;
        this.axios
          .get(
            this.api + '/api/user/dashboard/' + this.filter.year,
            {
              params: {
                banjar: this.userbanjar,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datacard = resdata.data;
              }
              // console.log(this.datacard);
            }
            this.loading.changedb = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changedb = false;
          });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
